import type { EnvName } from '@hbs-us/contracts';

/**
 * Resolve the running environment + tenant from the SPA host.
 *
 * The SPA is served from `{tenant}.<env>.qelm.app` (or `{tenant}.qelm.app` in
 * prod). We derive BOTH the env name (so apiFetch can pick the right api host
 * from `@hbs-us/contracts` `getEnvConfig`) and the tenant subdomain (the only
 * tenant signal the api host receives — sent as `X-Tenant-Subdomain`). Nothing
 * about the host is hardcoded here.
 */

const APP_ENV = (import.meta.env.VITE_APP_ENV as EnvName | undefined) ?? null;

/** Parse the env name out of the host: `acme.dev.qelm.app` -> 'dev'. */
function deriveEnvFromHost(hostname: string): EnvName {
  if (hostname.includes('.dev.')) return 'dev';
  return 'prod';
}

/** The first label of the host is the tenant subdomain: `acme.dev.qelm.app` -> 'acme'. */
function deriveTenantFromHost(hostname: string): string {
  const [first] = hostname.split('.');
  return first ?? '';
}

export function getAppEnv(): EnvName {
  if (APP_ENV) return APP_ENV;
  if (typeof window === 'undefined') return 'dev';
  return deriveEnvFromHost(window.location.hostname);
}

export function getTenantSubdomain(): string {
  if (typeof window === 'undefined') return '';
  return deriveTenantFromHost(window.location.hostname);
}
